import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Realisations from "@/pages/Realisations";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import Devis from "@/pages/Devis";
import Connexion from "@/pages/Connexion";
import { EspaceClientList, EspaceClientDetail } from "@/pages/EspaceClient";
import { AdminDashboard, AdminDevis, AdminContacts, AdminChantiers } from "@/pages/Admin";
import ChangePassword from "@/pages/ChangePassword";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="/connexion" element={<Connexion />} />

            <Route
              path="/espace-client"
              element={
                <ProtectedRoute requireRole="client">
                  <EspaceClientList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/espace-client/chantier/:id"
              element={
                <ProtectedRoute requireRole="client">
                  <EspaceClientDetail />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute requireRole="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/devis"
              element={
                <ProtectedRoute requireRole="admin">
                  <AdminDevis />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/contacts"
              element={
                <ProtectedRoute requireRole="admin">
                  <AdminContacts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/chantiers"
              element={
                <ProtectedRoute requireRole="admin">
                  <AdminChantiers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/chantier/:id"
              element={
                <ProtectedRoute requireRole="admin">
                  <EspaceClientDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/compte/mot-de-passe"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
